import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ComponentBase } from '@drl/core/component-base';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { CountryISO } from 'ngx-intl-tel-input';


const maxSizeInBytes = 5 * 1024 * 1024;
@Component({
  selector: 'app-upload-prescription-docs',
  templateUrl: './upload-prescription-docs.component.html',
  styleUrls: ['./upload-prescription-docs.component.scss'],
})
export class UploadPrescriptionDocsComponent extends ComponentBase {
  country = CountryISO.India;

  constructor(
    protected dialogRef: NbDialogRef<UploadPrescriptionDocsComponent>,
    protected readonly translateSvc: IpsTranslateService,
  ) {
    super();
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;
  uploadedFiles: File[] = [];
  imageData: File = null;
  disabled = false;

  @ViewChild('fileInput') fileInput: ElementRef;
  
  ngOnInit() {
    super.ngOnInit();
    this.uploadedFiles.forEach((file:any) => {
      file.isNotSaved=!file.id
    });
    if(this.uploadedFiles.length >= 5) {
      this.disabled = true;
    }
  }

  close() {
    this.dialogRef.close();
  }

  uploadFile(event) {
    this.fileInput.nativeElement.click();
  }

  fileProgress(fileInput) {
    const inputFiles = fileInput?.target?.files || [];
    for(let file of inputFiles) {
     file.status=file.size<=maxSizeInBytes;
     file.isNotSaved=!file.id
      this.uploadedFiles.push(file);
      if(this.uploadedFiles.length >= 5) {
        this.disabled = true;
        return;
      }
    }
  }

  removeFile(fileName: string) {
    this.uploadedFiles = this.uploadedFiles.filter(file => file.name !== fileName);
    if( this.uploadedFiles.length < 5) {
      this.disabled = false;
    }
  }
  
  continue() {
    this.dialogRef.close({
      uploadedFiles: this.uploadedFiles
    });
  }

  formatFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(2)} KB`;
    const mb = kb / 1024;
    if (mb < 1024) return `${mb.toFixed(2)} MB`;
    const gb = mb / 1024;
    return `${gb.toFixed(2)} GB`;
  }

  disableUpload(): boolean {
    return this.uploadedFiles.length === 0 || this.uploadedFiles.every((file: any) => file.id);
  }
  
  
}
